import { render, staticRenderFns } from "./AmapHeatmap.vue?vue&type=template&id=3477d456&scoped=true&"
import script from "./AmapHeatmap.vue?vue&type=script&lang=js&"
export * from "./AmapHeatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3477d456",
  null
  
)

export default component.exports